import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { AppVariants } from "common/types/appVariant";

import { isSignedIn } from "seneca-common/features/user/state";
import { useRedirectOnCondition } from "seneca-common/utils/hooks/routing";

import useAppVariant from "features/common/hooks/useAppVariant";
import { ROUTES } from "routing/routes";

import { SUGGESTED_PROVIDER_SEARCH_PARAM_KEY } from "../types";

export default function useRedirectToLoginSchool() {
  const signedIn = useSelector(isSignedIn);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isSenecaApp = useAppVariant() === AppVariants.seneca;

  const shouldRedirect =
    !signedIn &&
    searchParams.has(SUGGESTED_PROVIDER_SEARCH_PARAM_KEY) &&
    isSenecaApp;

  const redirectLocation = {
    ...location,
    pathname: ROUTES.LOGIN_SCHOOL.buildPath({}),
    state: {
      ...location.state,
      redirectAuthenticatedUserToLocation: location
    }
  };

  useRedirectOnCondition(shouldRedirect, redirectLocation);
}
